// ----------------------------------------------------------------------

function apiPath(root: string, endpoint: string) {
  return `${root}${endpoint}`;
}

const PUBLIC_FOLDER = '/uploads';
const PUBLIC_FOLDER_USER = `${PUBLIC_FOLDER}/user`;
const PUBLIC_FOLDER_PRODUCT = `${PUBLIC_FOLDER}/product`;
const PUBLIC_FOLDER_NEWSLETTER = `${PUBLIC_FOLDER}/newsletter`;

const API_ROOT = '/api';
const API_AUTH = `${API_ROOT}/Auth`;
const API_COMPANY = `${API_ROOT}/Company`;
const API_PRODUCT = `${API_ROOT}/Product`;
const API_VEHICLE = `${API_ROOT}/Vehicle`;
const API_WORKER = `${API_ROOT}/Worker`;
const API_NEWSLETTER = `${API_ROOT}/NewsLetter`;
const API_RATE = `${API_ROOT}/Rate`;
const API_UTILITY = `${API_ROOT}/Utility`;
const API_USERS = `${API_ROOT}/Users`;
const API_ORDERS = `${API_ROOT}/Order`;
const API_Pay = `${API_ROOT}/Pay`;
const API_ACCOUNT = `${API_ROOT}/Account`;
const API_SUBSCRIPTION = `${API_ROOT}/Subscription`;
const API_PRINTS = `${API_ROOT}/Print`;

// ----------------------------------------------------------------------

export const API_ENDPOINTS = {
  // Authentication endpoints
  auth: {
    login: apiPath(API_AUTH, '/login'),
    register: apiPath(API_AUTH, '/register'),
  },

  // Company endpoints
  company: {
    root: API_COMPANY,
    getAll: API_COMPANY,
    create: API_COMPANY,
    getById: (id: string) => apiPath(API_COMPANY, `/${id}`),
    update: (id: string) => apiPath(API_COMPANY, `/${id}`),
    delete: (id: string) => apiPath(API_COMPANY, `/${id}`),
    bulk: apiPath(API_COMPANY, '/bulk'),
    updateStatus: (id: string, status: boolean) =>
      apiPath(API_COMPANY, `/${id}/status?status=${status}`),
    getProducts: apiPath(API_COMPANY, '/products'),
    updateProducts: apiPath(API_COMPANY, '/products'),
  },

  // Product endpoints
  product: {
    root: API_PRODUCT,
    getAll: API_PRODUCT,
    create: API_PRODUCT,
    getById: (id: string) => apiPath(API_PRODUCT, `/${id}`),
    update: (id: string) => apiPath(API_PRODUCT, `/${id}`),
    delete: (id: string) => apiPath(API_PRODUCT, `/${id}`),
    bulk: apiPath(API_PRODUCT, '/bulk'),
    updateStatus: (productId: string, status: boolean) =>
      apiPath(API_PRODUCT, `/${productId}/status?status=${status}`),
    upload: apiPath(API_PRODUCT, '/upload'),
  },

  // Rate endpoints
  rate: {
    root: API_RATE,
    getAll: API_RATE,
    addUpdate: apiPath(API_RATE, '/addupdate'),
    bulk: apiPath(API_RATE, '/bulk'),
    history: apiPath(API_RATE, '/getratehistory'),
  },

  // Utility endpoints
  utility: {
    root: API_UTILITY,
    states: apiPath(API_UTILITY, '/states'),
    cities: (stateCode: string) => apiPath(API_UTILITY, `/cities/${stateCode}`),
    company: (companyId: string) => apiPath(API_UTILITY, `/company?Id=${companyId}`),
    distributors: (isActive = true, isDeleted = false) =>
      apiPath(API_UTILITY, `/distributors?IsActive=${isActive}&IsDeleted=${isDeleted}`),
    retailers: (parentId: string, isActive = true, isDeleted = false) =>
      apiPath(API_UTILITY, `/retailers?ParentId=${parentId}&IsActive=${isActive}&IsDeleted=${isDeleted}`),
    products: (companyId: string) => apiPath(API_UTILITY, `/products/${companyId}`),
    getcompanies: (isActive = true, isDeleted = false) =>
      apiPath(API_UTILITY, `/companies?IsActive=${isActive}&IsDeleted=${isDeleted}`),
    checkmanageorderrights: apiPath(API_UTILITY, '/checkmanageorderrights'),
    hasappaccountingrights: apiPath(API_UTILITY, '/hasappaccountingrights'),
    hasrightstoaccountledger: apiPath(API_UTILITY, '/hasrightstoaccountledger'),
    hasrightstosalespurchaseregister: apiPath(API_UTILITY, '/hasrightstosalespurchaseregister'),
  },

  // Users endpoints
  users: {
    root: API_USERS,
    getAll: API_USERS,
    create: API_USERS,
    getById: (id: string) => apiPath(API_USERS, `/${id}`),
    update: (id: string) => apiPath(API_USERS, `/${id}`),
    delete: (id: string) => apiPath(API_USERS, `/${id}`),
    myAccount: apiPath(API_USERS, '/my-account'),
    bulk: apiPath(API_USERS, '/bulk'),
    updateStatus: (id: string, status: boolean) =>
      apiPath(API_USERS, `/${id}/status?status=${status}`),
    upload: apiPath(API_USERS, '/upload'),
  },

  orders: {
    root: API_ORDERS,
    getAllOrder: apiPath(API_ORDERS, '/getOrderbyday'),
    get: apiPath(API_ORDERS, '/getorderinfo'),
    save: apiPath(API_ORDERS, '/addupdate'),
    getretailersorders: apiPath(API_ORDERS, '/getretailersorders'),
    getDistributorOrders: apiPath(API_ORDERS, '/getordersfordistributor'),
    getDistributorSummary: apiPath(API_ORDERS, '/getdaysummary'),
    saveBulk: apiPath(API_ORDERS, '/savebulkorders'),
    getAuditLogs: apiPath(API_ORDERS, '/getorderauditlogs'),
    verifyAuditPassword: apiPath(API_ORDERS, '/verifyauditpassword'),
  },

  pay: {
    root: API_Pay,
    toUser: apiPath(API_Pay, '/touser')
  },

  account: {
    root: API_ACCOUNT,
    getAccountInfo: apiPath(API_ACCOUNT, '/getaccountinfo'),
    getTransactions: apiPath(API_ACCOUNT, '/gettransactions'),
    addTransaction: apiPath(API_ACCOUNT, '/addtransaction'),
    getbulkpaymentinfo: apiPath(API_ACCOUNT, '/getbulkpaymentinfo'),
    acceptbulkpayment: apiPath(API_ACCOUNT, '/acceptbulkpayment'),
  },

  subscription: {
    root: API_SUBSCRIPTION,
    getSubscription: API_SUBSCRIPTION,
    updateSubscription: apiPath(API_SUBSCRIPTION, '/updatesubscription'),
  },

  vehicle: {
    root: API_VEHICLE,
    getAll: API_VEHICLE,
    create: API_VEHICLE,
    getById: (id: string) => apiPath(API_VEHICLE, `/${id}`),
    update: (id: string) => apiPath(API_VEHICLE, `/${id}`),
    delete: (id: string) => apiPath(API_VEHICLE, `/${id}`),
    bulk: apiPath(API_VEHICLE, '/bulk')
  },

  worker: {
    root: API_WORKER,
    getAll: API_WORKER,
    create: API_WORKER,
    getById: (id: string) => apiPath(API_WORKER, `/${id}`),
    update: (id: string) => apiPath(API_WORKER, `/${id}`),
    delete: (id: string) => apiPath(API_WORKER, `/${id}`),
    bulk: apiPath(API_WORKER, '/bulk')
  },

  newsletter: {
    root: API_NEWSLETTER,
    getAll: apiPath(API_NEWSLETTER, '/getallnewsletters'),
    create: API_NEWSLETTER,
    getById: (id: string) => apiPath(API_NEWSLETTER, `/${id}`),
    update: (id: string) => apiPath(API_NEWSLETTER, `/${id}`),
    delete: (id: string) => apiPath(API_NEWSLETTER, `/${id}`),
    upload: apiPath(API_NEWSLETTER, '/upload'),
  },

  prints: {
    root: API_PRINTS,
    getSalesInvoice: apiPath(API_PRINTS, '/salesinvoice'),
    getPurchaseInvoice: apiPath(API_PRINTS, '/purchaseinvoice'),
    getPurchaseBill: apiPath(API_PRINTS, '/purchasebill'),
    getCollection: apiPath(API_PRINTS, '/collection'),
    getDelivery: apiPath(API_PRINTS, '/delivery'),
    getCompanyMaster: apiPath(API_PRINTS, '/companymaster'),
    getProductMaster: apiPath(API_PRINTS, '/productmaster'),
    getsalespurchaseregister: apiPath(API_PRINTS, '/salespurchaseregister'),
    getproductledger: apiPath(API_PRINTS, '/productledger'),
    getaccountledger: apiPath(API_PRINTS, '/accountledger'),
    getExportCompanies: apiPath(API_PRINTS, '/exportcompanies'),
    getExportProducts: apiPath(API_PRINTS, '/exportproducts'),
    getExportUsers: apiPath(API_PRINTS, '/exportusers'),
    getExportVehicles: apiPath(API_PRINTS, '/exportvehicles'),
    getExportWorkers: apiPath(API_PRINTS, '/exportworkers'),
  },

  // Public Folders
  publicFolder: {
    getUserProfilePic: (id: string) => apiPath(PUBLIC_FOLDER_USER, `/${id}`),
    getProductPic: (id: string) => apiPath(PUBLIC_FOLDER_PRODUCT, `/${id}`),
    getNewsletterPic: (id: string) => apiPath(PUBLIC_FOLDER_NEWSLETTER, `/${id}`),
  },
};
